import {Modal} from "antd";
import React, {useEffect, useState} from "react";
import {Navigate, useParams} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import '../assets/css/Dentobook.css';
import {getOrganizationApi} from "../api/apiInstances";
import {Organization} from "../api-client";
import DetailWrapper from "../components/common/DetailWrapper";
import OrganizationDetailsView from "../components/organizations/OrganizationDetailsView";
import OrganizationForm from "../components/organizations/OrganizationForm";
import {accessibilityRoles} from "../utils/accessUtils";
import AccessControl from "../components/common/AccessControl";
import logger from "../utils/logger";

const OrganizationDetails = () => {

    const {id} = useParams();

    const [organization, setOrganization] = useState<Organization | undefined>(undefined);
    const [editMode, setEditMode] = useState<boolean>(false);

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const [goBack, setGoBack] = useState<boolean>(false);

    const organizationApi = getOrganizationApi();

    useEffect(() => {
        if (id == null) {
            return;
        }

        organizationApi.fetchOrganizationById(id)
            .then((response) => {
                setOrganization(response.data);
            })
            .catch(err => {
                logger.log(err);
            });
    }, []);

    const handleOk = () => {
        setIsModalOpen(false);

        setGoBack(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    if (goBack) {
        return <Navigate to="/organizations"/>;
    }

    if (!organization) {
        return null;
    }

    return (
        <AccessControl accessibleFor={[accessibilityRoles.PLATFORM_ADMINISTRATOR]}>
            <Modal
                transitionName=""
                className="dentobook-modal"
                okButtonProps={{
                    className: "modal-btn"
                }}
                cancelButtonProps={{
                    className: "modal-btn"
                }}
                okText={<FormattedMessage id="confirm"/>}
                cancelText={<FormattedMessage id="cancel"/>}
                open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <h3 className="dentobook-content font-weight-500 font-24 text-align-center"><FormattedMessage
                    id="unsaved_changes"/></h3>
            </Modal>
            <DetailWrapper navigateBack="/organizations">
                {editMode ?
                    <>
                        <h2><FormattedMessage id="edit_organization"/></h2>
                        <OrganizationForm clinic={organization} openModal={() => setIsModalOpen(true)}/>
                    </>
                    :
                    <OrganizationDetailsView organization={organization} setEditMode={setEditMode}/>}
            </DetailWrapper>
        </AccessControl>
    );
};

export default OrganizationDetails;